import { render, staticRenderFns } from "./SocialCarousel.vue?vue&type=template&id=539665d4"
import script from "./SocialCarousel.vue?vue&type=script&lang=js"
export * from "./SocialCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports